import {
  buildSort,
  buildRelevanceSortCriterion,
  SortOrder,
  buildFieldSortCriterion,
} from '@coveo/headless';
import headlessEngine from './headlessEngine';

export const getSortCriteria = function (dropDownValues: any) {
  const MostRelevantAvailable = dropDownValues?.find(
    (item: any) => item?.fields?.key?.value === 'Most relevant'
  );
  const sortByFields = MostRelevantAvailable
    ? [
        [
          MostRelevantAvailable?.fields?.label?.value || 'Most relevant',
          buildRelevanceSortCriterion(),
        ],
      ]
    : [];

  dropDownValues?.forEach((item: any) => {
    if (item?.fields?.key?.value !== 'Most relevant') {
      sortByFields.push([
        item?.fields?.label?.value,
        buildFieldSortCriterion(
          item?.fields?.coveoSortFieldName?.value,
          item?.fields?.isDescending?.value ? SortOrder.Descending : SortOrder.Ascending
        ),
      ]);
    }
  });

  return sortByFields;
};

export const getSortController = function (dropDownValues: any) {
  return buildSort(headlessEngine, {
    initialState: { criterion: getSortCriteria(dropDownValues)[0][1] as any },
  });
};
